<style scoped>
th, td {
  padding: 4px;
  text-align: center;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div v-loading="loading">
    <mu-button
      icon
      class="float-right"
      @click="$emit('close')"
      >
      <mu-icon value="close" />
    </mu-button>
    <mu-card-text>
      <h2>{{$t('AnalyticsDuration.title')}}</h2>
    </mu-card-text>
    <div v-if="data.length > 0 && media">
      <chart 
        :option="chartOption" 
        id="AnalyticsVideoDuration" 
        height="300px" 
        />
    </div>
  </div>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import timeFormatter from '@/utils/timeFormatter.js'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'AnalyticsDuration',
  props: ["channel", "media"],
  mixins: [theme],
  components: {
    chart,
  },
  data() {
    return {
      data: [],
      total: 0,
      loading: false,
    };
  },
  watch: {
  },
  computed: {
    timeline() {
      return Array.from(Array(Math.round(((this.media ? this.media.duration : 0) + 1))).keys()).map(i => timeFormatter(i))
    },
    computedData() {
      return this.data.map(i => i / this.total * 100);
    },
    chartOption() {
      return {
        title : {
          text: this.$t('AnalyticsDuration.titleWithName', { name: this.media.name }),
          x: 'center',
          textStyle: {
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          data: this.timeline
        },
        yAxis: {
          type: 'value',
          name: '%',
          minInterval: 1,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          },
        },
        legend: {
          x : 'center',
          y : 'bottom',
          data: this.legends
        },
        calculable : true,
        series : [
          {
            type: 'line',
            data: this.computedData,
            itemStyle: {
              normal: {
                color: this.themePrimaryColor
              }
            }
          },
        ]
      }
    },
  },
  mounted() {
    this.getData(this.media._id);
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    getData(mediaId) {
      this.loading = true;
      axios
      .get(this.$store.getters.urlApi + "analytics/duration/media/" + mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      })
      .then(response => {
        this.data = response.data.data.data;
        this.total = response.data.data.total;
        this.loading = false;
      });
    },
  },
};
</script>
